/**
 * Razorpay Configuration - Client-Side Only
 * Contains API keys and configuration for Razorpay payment gateway
 * Works without backend - uses n8n webhooks for database updates
 */

export const razorpayConfig = {
  // Live Production Keys
  keyId: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_live_RrmBuhqdu1qip6',
  keySecret: process.env.REACT_APP_RAZORPAY_KEY_SECRET || 'p7eOaNKxEoso3gXqZ6Khzks1',
  
  // n8n Webhook URL for database updates
  // Configure this in your .env file: REACT_APP_N8N_WEBHOOK_URL
  n8nWebhookUrl: process.env.REACT_APP_N8N_WEBHOOK_URL || '',
  
  // Currency
  currency: 'INR',
  
  // Company Details
  companyName: 'Wellness',
  companyLogo: '/media/logos/futurisk-logo.png', // Update with your logo path
  
  // Theme Configuration
  theme: {
    color: '#3399cc',
    backdrop_color: 'rgba(0, 0, 0, 0.5)',
  },
  
  // Modal Configuration
  modal: {
    ondismiss: () => {
      console.log('Payment modal closed');
    },
    escape: true,
    backdropclose: false,
  },
};

// Environment check
export const isProduction = process.env.NODE_ENV === 'production';

// Razorpay Script URL
export const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';
